<template>
  <SecondaryModal v-if="chat" name="delete-chat" :title="$t('chat.deleteChatTitle')" @before-open="reset">
    <div v-html="$t('chat.deleteChatConfirmation', { name: chatName })"></div>
    <!-- <div v-if="isPrivate" :class="$style.switchContainer">
      <BaseSwitch v-model="isDeleteForAll">Delete for me and {{ receiver }}</BaseSwitch>
    </div> -->

    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide('delete-chat')">{{ $t('buttonCancel') }}</BaseButton>
      <BaseButton oval :loading="loading" @click="deleteRequest">{{ $t('buttonDelete') }}</BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from './SecondaryModal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'delete-chat-popup',
  components: {
    SecondaryModal
  },
  data () {
    return {
      loading: false
      // isDeleteForAll: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      chatById: 'entities/chats/getById',
      chat: 'entities/chats/activeChat'
    }),
    isPrivate () {
      if (!this.chat) return
      return this.chat.typeName === 'one-to-one'
    },
    receiver () {
      if (!this.isPrivate) return
      return this.chat.participantsUsers.find(user => user && user.userId !== this.user.id)
    },
    chatName () {
      if (!this.isPrivate) return this.chat.name
      return this.receiver && this.receiver.displayName
    }
  },
  methods: {
    ...mapActions({
      remove: 'entities/chats/remove',
      leave: 'entities/chats/leave'
    }),
    reset () {
      this.loading = false
      this.isDeleteForAll = false
    },
    async deleteRequest () {
      this.loading = true
      // const deleteForAll = this.isPrivate ? true : this.isDeleteForAll
      await this.remove({
        id: this.chat.id
      })
      this.loading = false
      this.$modal.hide('delete-chat')
      this.$modal.hide('group-profile')
    }
  }
}
</script>

<style module lang="scss">
.switchContainer {
  margin-top: 8px;
  display: inline-block;
}
</style>
